module.exports = __webpack_public_path__ + "static/graph-ea5eeee59b7d6d5857f43707dbb659b9.png";